import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { resolve, reject } from 'q';
import {AuthenticationService} from './authentication.service'
import { environment } from "../../environments/environment";
import { encode } from 'punycode';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from "ngx-cookie-service";
import {Router} from "@angular/router"
// import { AlertService } from './alert.service';

@Injectable()
export class ProfileService {
    private profile:any;
    private users:any;
    private userOne:any;
    private user = new BehaviorSubject<string>('');
    cast = this.user.asObservable();
    constructor(
        private http: HttpClient,
        public as: AuthenticationService,
        private cookieService: CookieService,
        private router: Router,) {
    };

    private inventories:any;
    private il = new BehaviorSubject<string>('');
    inventory = this.il.asObservable();
    public getProfile() {
        const profileObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/profile`)
            .subscribe(response => {
                this.profile = response;
                console.log(this.profile)
                if(this.profile && this.profile.message){
                    this.as.logout().subscribe(response => {
                        this.cookieService.delete('incontrol');
                        localStorage.removeItem('incontrol._access_token');
                        this.router.navigate(['/login'])
                    }, error => {
                        this.cookieService.delete('incontrol');
                        localStorage.removeItem('incontrol._access_token');
                    })
                    observer.next(this.profile.message);
                }else{
                    this.user.next(this.profile);
                    observer.next(response);
                }
            }, error => {
                console.log(error)
                this.as.logout().subscribe(response => {
                    this.router.navigate(['/login'])
                    console.log(response)
                    this.cookieService.delete('incontrol');
                    localStorage.removeItem('incontrol._access_token');
                }, error => {
                    this.router.navigate(['/login'])
                    this.cookieService.delete('incontrol');
                    localStorage.removeItem('incontrol._access_token');
                })
                observer.next(error.reason);
            })
        });
        return profileObservable; 
    } // prifle end*/
    public getUsers(data) {
        const getUsersObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/user?page=${data.page}&offset=${data.offset}&orderby=${data.orderby}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getUsersObservable; 
    } // prifle end*/
    public getUser(user) {
        const getUserObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/user/${user}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getUserObservable; 
    } // prifle end*/
    public getRole() {
        const getRoleObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/role`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getRoleObservable; 
    } // prifle end*/
    public updateUser(user){
        const updateUserObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/user/${user.code}`,user)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateUserObservable;  
    }
    public deleteUser(user){
        const deleteUserObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/user/${user.code}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteUserObservable;  
    }
    public newUser(user){
        console.log(user);
        const updateUserObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/user/`,user)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateUserObservable;  
    }
    public recoveryPassword(data){
        const recoveryPasswordObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/recovery`,data)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return recoveryPasswordObservable; 
    }
    public updatePassword(data){
        const recoveryPasswordObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/recovery`,data)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return recoveryPasswordObservable; 
    }

} // class

// Mon Apr 15 2019 13:33:13 GMT-0600